import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function Client() {

    return (
        <>
            <section className='achievement-section' style={{ backgroundColor: '#101218' }}>
                <div class="janhappyclients">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-5 col-12">
                                <div data-aos="fade-right">
                                    <h3>Our Customer</h3>
                                    <p>Our partner continuously inspires and uplifts me, celebrating every achievement. Their boundless enthusiasm ignites my creativity, It is creating a vibrant collaborative environment that nurtures growth and paves the way for shared success.</p>
                                    <br />
                                    <div className='button_grp'>
                                        <Link to="/contact-us" class="gradent-btn">Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7 col-12">
                                <div className='row'>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-1.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-2.png')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-3.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-4.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-5.png')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-6.png')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-7.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/f-8.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-4 mt-3 col-6'>
                                        <div className='partner-item'>
                                            <img src={require('../assets/images/client/c-8.webp')} alt='' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
